import React from 'react';
// , { useState, useEffect }
import axios from 'axios';
import { apiUrl } from 'Api/Api';

export async function UploadAsset (props) {

  const required_props = [
    'entity_type',
    'entity_uuid',
    'asset_data',
    'asset_type'
  ];

  //console.log("UploadAsset",props);
  
  //const [entity_type] = useState(props.entity_type);
  //const [entity_uuid] = useState(props.entity_uuid);
  //const [file] = useState(props.file);
  //const [file_name] = useState(props.file_name);
  //const [asset_type] = useState(props.asset_type);
  
  //const [asset_url,setAssetUrl] = useState(''); // set when done
  //const [onProgressDisplayUpdate] = useState(props.onProgressDisplayUpdate || null);
  //const [onProgressPercentUpdate] = useState(props.onProgressPercentUpdate || null);
  
  //const [progress_display,setProgressDisplay] = useState(<React.Fragment></React.Fragment>)
  //const [progress_percent,setProgressPercent] = useState(0);
  
  const uploadAsset = async (config) => {
    console.log("UploadAsset", config);
    let asset_data_promise = new Promise(resolve => {
      let reader = new FileReader();
      reader.readAsArrayBuffer(config.asset_data);
      reader.onload = () => resolve(reader.result);
    });
    let asset_file_name;
    if (config.asset_data.name) {
      // image file - could be .jpg, .png, .gif, etc.
      asset_file_name = config.entity_type+'_'+config.asset_type+'_'+(new Date().getTime())+'.'+config.asset_data.name.split('.').pop();
    } else {
      // recorded audio - will be webm or wav or mp4
      let extension = 'webm';
      if (config.asset_data && config.asset_data.type) {
        if (config.asset_data.type.startsWith('audio/wav')) {
          extension = "wav";
        } else if (config.asset_data.type.startsWith('audio/mp4')) {
          extension = "mp4";
        }
      }
      asset_file_name = config.entity_type+'_'+config.asset_type+'_'+(new Date().getTime())+'.'+extension;
    }
    let params = {
      asset_type: config.asset_type, // image or audio
      filename: asset_file_name
    };
    let gsu_response = await axios.post(`${apiUrl}${config.entity_type}/${config.entity_uuid}/getUploadSignedUrl`,{}, { params });
    
    let raw_asset_data = await asset_data_promise;
    let asset_length_bytes = raw_asset_data.byteLength;
    let pretty_asset_type = '';
    if (config.asset_type === 'raw_audio') {
      pretty_asset_type = 'Audio';
    } else {
      pretty_asset_type = 'Image';
    }
    const signed_url_upload_config = {
      headers: { "Content-Type": gsu_response.data.content_type },
      onUploadProgress: (progressEvent) => {
        let upload_percent = Math.floor(progressEvent.loaded / asset_length_bytes * 100);
        //console.log("SLIDE UPLOADING PROGRESS ("+i+")",progressEvent.loaded,upload_percent);
        if (props.onProgressPercentUpdate) {
          props.onProgressPercentUpdate(upload_percent);
        }
        if (props.onProgressDisplayUpdate) {
          props.onProgressDisplayUpdate(<span style={{ color: 'green' }}>{'Uploading '+pretty_asset_type+' '+upload_percent+'%'}</span>);
        }
      }
    };
    let upload_url = gsu_response.data.upload_url;
    
    await axios.put(upload_url, raw_asset_data, signed_url_upload_config);
    
    return gsu_response.data.asset_url;
  };

  for (let required_prop of required_props) {
    if (!props[required_prop]) {
      return null;
    }
  }
  const upload_asset_config = {
    asset_data: props.asset_data,
    entity_type: props.entity_type,
    entity_uuid: props.entity_uuid,
    asset_type: props.asset_type
  };
  const asset_url = await uploadAsset(upload_asset_config);
    
  return asset_url;
}

